var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m28.998 8.531-2.134-2.134a1.006 1.006 0 0 0-1.423 0L12.646 19.192l-6.086-6.13a1.006 1.006 0 0 0-1.423 0l-2.134 2.134a1.006 1.006 0 0 0 0 1.423l8.924 8.984c.393.393 1.03.393 1.423 0L28.998 9.954a1.006 1.006 0 0 0 0-1.423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.97659c7d993ce7397516a1b82375eb1b.svg";
export { ForwardRef as ReactComponent };